import React from "react";
import { connect } from 'react-redux';
import Popover from '@material-ui/core/Popover';
import Paper from '@material-ui/core/Paper';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
// import Chip from '@material-ui/core/Chip';
import jsPDF from 'jspdf'
// import { TextField } from '@material-ui/core';
// import RegIcon from '@material-ui/icons/Description';
import k1 from 'assets/img/kj.png';
// import Tabs from '@material-ui/core/Tabs';
// import Tab from '@material-ui/core/Tab';
// import Paper from '@material-ui/core/Paper';
// import fs from 'fs';
// import MUIDataTable from "mui-datatables";
// import {htmlDocx, saveAs} from 'html-docx-js'
// import * as fs from "fs";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
// import CircularProgress from '@material-ui/core/CircularProgress'
// import k2 from 'assets/img/kj2.png';
import k3 from 'assets/img/kj3.png';
import { Link } from "react-router-dom";
import axios from 'axios';
import CommentIcon from '@material-ui/icons/Comment';
import logo1 from 'assets/img/noimage1.jpg';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import WT from '@material-ui/icons/WhatsApp';
import ML from '@material-ui/icons/MailOutline';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from "@material-ui/core/styles";
// import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import { Button, Row, DropdownMenu, DropdownItem, Col, FormGroup, Input, Modal, UncontrolledDropdown, DropdownToggle } from "reactstrap";
import moment from "moment";
import { Edit } from "@material-ui/icons";
// import MUIDataTable from "mui-datatables";
import Hover from './Hover'
// import HTMLtoDOCX from 'html-to-docx/dist/html-to-docx.esm';


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            maxWidth: '100%',
            display: 'flex',
        },
        tabs: {
            backgroundColor: '',
            boxShadow: 'none'
        },
        // c,over: {
        //     flex: '1 0 auto',
        //     width: 151,
        //     paddingTop: '70.25%'
        // },
        content: {
        },
        media: {
            height: 0,
            paddingTop: '70.25%', // 16:9
        },
        expand: {
            transform: 'rotate(0deg)',
            marginLeft: 'auto',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
        },
        expandOpen: {
            transform: 'rotate(180deg)',
        },
        small: {
            width: theme.spacing(3),
            height: theme.spacing(3),
        },
        avatar: {
            backgroundColor: red[500],
        },
        avatar2: {
            height: '95%',
            width: '87%',
            marginLeft: '5px'
        },
        popover: {
            pointerEvents: 'none',
        },
        paper: {
            width: '300px',
            height: '90px',
            backgroundColor: '',
            zIndex: 90,
            // boxShadow: 'none',
            border: '1px solid #E8E8E8'
        },
        paper2: {
            width: '0px',
            height: '0px',
            backgroundColor: 'transparent !important',
            boxShadow: 'none',
        },
        paper3: {
            width: '80px',
            height: '120px',
            boxShadow: 'none',
            backgroundColor: 'transparent'
        },
        offerSelf: {
            width: 'auto',
            // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
            float: 'right',
            maxWidth: '90%',
            padding: '5px 20px',
            borderRadius: '30px',
            backgroundColor: '#cbe4f9',
            maxHeight: '350px'
        },
        offerOther: {
            width: 'auto',
            // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
            float: 'left',
            maxWidth: '90%',
            padding: '5px 20px',
            borderRadius: '30px',
            backgroundColor: '#f9d8d6',
            maxHeight: '350px'
        },
        fulldiv: {
            width: '100%',
            backgroundColor: '',
            float: 'left',
            marginTop: '5px',
            height: "auto",
            maxHeight: '350px'
        },
    }),
);

const useStyles2 = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            margin: 'auto',
            // maxWidth: 500,
        },
        image: {
            width: 350,
            height: 350,
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },
    }),
);


const Header = (props) => {




    const CTooltip = withStyles({
        tooltip: {
            fontSize: "15px",
            // color: "black",
            color: props.theme === 'white' ? 'black' : props.theme === 'dark' ? '#adb5bd' : '#adb5bd',
            backgroundColor: props.theme === 'white' ? 'white' : props.theme === 'dark' ? 'black' : '#16141f',
            // backgroundColor: "white",
            padding: '10px',
            border: props.theme === 'white' ? '1px solid #e5e6ee' : props.theme === 'dark' ? '1px solid #121212' : '1px solid #121212',
            // border: ,
            boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
        }
    })(Tooltip);






    var nb = props.event.by.first_name.substring(0, 1)
    const classes = useStyles();
    // var curdate = new Date()
    // curdate = moment(curdate).format('YYYY-MM-DD')
    const classes2 = useStyles2();
    const [expanded, setExpanded] = React.useState(false);
    const [media, setmedia] = React.useState(false);
    const commentinput = React.useRef()
    const [comments, setcomments] = React.useState(false);
    const [allcomments, setallcomments] = React.useState([]);
    // const [registrations, setregistrations] = React.useState([]);
    const [aname, setaname] = React.useState(false);
    const [file, setfile] = React.useState(false);
    const [deleve, setdeleve] = React.useState(false);
    // const [editcontent, seteditcontent] = React.useState('Add');
    // const [dcontent, setdcontent] = React.useState(false);
    // const [editcontent2, seteditcontent2] = React.useState('Add');
    // const [dcontent2, setdcontent2] = React.useState(false);
    // const [afile, setafile] = React.useState();
    const [markas, setmarkas] = React.useState(false);
    const [proimage, setpro] = React.useState();
    const [sendingdata, setSendingdata] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // const hiddenFileInput = React.useRef(null);
    // const [filename, setfilename] = React.useState('Choose a file');
    // const [emailtool, setemailtool] = React.useState(false);
    const [tt, settt] = React.useState('');
    const [emailsel, setemailsel] = React.useState('Click to Copy Email');
    const [incomment, setincomment] = React.useState('');
    // const [register, setregister] = React.useState(false);
    // const [regs, setregs] = React.useState(false);
    // const [addReport, setaddReport] = React.useState(false);
    // const [getreport, setgetreport] = React.useState({});
    // const [report, setreport] = React.useState({})
    // const [regdetails, setregdetails] = React.useState({ 'name': '', 'reason': '' });
    // const [anchorEl, setAnchorEl] = React.useState < HTMLElement | null > (null);
    let [anchorEl2, setAnchorEl2] = React.useState();


    // const history = useHistory();
    const event = props.event;
    const fetchData = React.useCallback(() => {
        axios.get(process.env.REACT_APP_DOMAIN+"/profile/user=" + event.by.id, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                if (response.data.photo != null) {
                    // console.log('present')
                    if (response.data.photo.length > 1) {
                        // console.log('yes')
                        // console.log(process.env.REACT_APP_DOMAIN+'' + response.data.photo)
                        setpro(process.env.REACT_APP_DOMAIN+'' + response.data.photo)
                        // setyes(true)
                    }
                }
                setaname(nb)
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went Wrong')
                settt('error')
                setOpen(true)
            })
        axios.get(process.env.REACT_APP_DOMAIN+"/comments/preevent=" + event.id, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setallcomments(response.data)
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went Wrong')
                settt('error')
                setOpen(true)
            })
        setaname(nb)
    }, [event.by.id, event.id, nb, props.token])
    React.useEffect(() => {
        fetchData()
        document.addEventListener("keydown", escFunction, false);
    }, [fetchData])






    const openFile = (e) => {
        console.log(e)
        setAnchorEl2(e.currentTarget);
        setfile(!file)
    };

    // const copyToClipboard = (e) => {
    //     navigator.clipboard.writeText(e);
    //     setemailsel('Copied the Email')
    // };


    const CloseMarkas = () => {
        setmarkas(false)
    };


    const CloseComments = () => {
        setcomments(false)
    };


    const handleClose = () => {
        setOpen(false)
    };

    const closeFile = (event) => {
        setfile(false)

    };
    const handleMedia = (event, img) => {
        // console.log(event)
        // console.log(img)
        // console.log('clicked')
        setmedia(true)
    };
    const CloseMedia = () => {
        setmedia(false)
    };


    const addComment = () => {
        if (incomment === undefined) {
            settt('error')
            setSendingdata('Please add Something')
            setOpen(true)
            return 0;
        }
        if (incomment.length < 1) {
            settt('error')
            setSendingdata('Please add Something')
            setOpen(true)
            return 0;
        }
        var inp = { 'comment': incomment }
        axios.post(process.env.REACT_APP_DOMAIN+'/addcomment/preevent=' + event.id, inp, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setincomment('')
                fetchData()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
            })
    };


    const markEventAs = (par) => {
        // console.log(par)
        axios.get(process.env.REACT_APP_DOMAIN+'/mark-preevent=' + event.id + '/as=' + par, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                console.log(response.data)
                setmarkas(false)
                setSendingdata('Successfully Done')
                settt('success')
                setOpen(true)
                fetchData()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
            })
    };
    const handleExpandClick = () => {
        setcomments(true);
        // commentinput.focus()
    };
    const handleExpandClick2 = () => {
        setExpanded(!expanded);
        // commentinput.focus()
    };
    // console.log(nb)
    // console.log(event)
    // console.log(event.pdate)
    // var last2 = moment(event.edate).fromNow()
    // var last = moment(event.edate).format('Do MMM YYYY')
    var pdate = moment(event.pdate).format('Do MMM YYYY')
    // console.log(last)
    // const [star, setstar] = React.useState(false);
    // const [yes, setyes] = React.useState(false);
    // console.log(event.poster)
    // console.log(pos)

    const escFunction = (e) => {
        // console.log(e.keyCode)
        if ((e.metaKey || e.shiftKey) && e.keyCode === 80) {
            //Do whatever when esc is pressed
            // CreatePdf()
        }
    }
    const sendmsg = () => {
        setmedia(false)
        var msgbody1 = "K.J. somaiya Institute of Engineering and Information Technology (KJSIEIT) Sion, Mumbai %0D%0A"
        var msgbody2 = "KJSIEIT is accredited by NAAC with A grade Three programs accredited by National Board of Accreditation Best College awarded by University of Mumbai, ISTE (MH) and CSI (Mumbai) %0D%0A"
        var cname = "KJSIEIT-" + event.organizer + " is organizing a " + event.etype + ' on topic *' + event.title + '* for ' + event.target + ' %0D%0A'
        var dty = 'Date : ' + event.date + '%0D%0A Time : ' + event.tfrom + ' - ' + event.tto + '%0D%0A'
        // to = " to "
        // descc = "Description : "
        // speaker = "Speaker : "
        // msgbody4 = dte.concat(delldate, str, tme, dellfro, to, dellto, str, speaker, dellpres, sp, dellpresd, fustp)
        // msgbody5 = str.concat(str, descc, delldesc)
        // if (dellperks != undefined) {
        //     msgbodyo = msgbody5.concat(str, dellperks);
        // }
        // subj = delltitle
        // reg = "Meeting Link : "
        // msgbody5 = reg.concat(space, delllink, str, dellregfro, to, dellregto)
        // dep = "Department : "
        // faccod = "Faculty Co-ordinators : "
        // conv = "Conveners : "
        // cont = "Contact : "
        // msgbody6 = faccod.concat(dellfaccod1, sp, dellfaccod2, sp, dellfaccod3, str, conv, dellconv1, sp, dellconv2, str, cont, dellcont1, dellcont2)
        var msgbodyf = msgbody1 + msgbody2 + cname + dty
        // console.log(msgbodyf)
        let url = 'whatsapp://send?text=' + msgbodyf + '';
        window.open(url);
    }

    // const copy = () => {
    //     /* Get the text field */
    //     var copytext = event.mlink;
    //     // copytext.select();
    //     // copytext.setSelectionRange(0, 99999);
    //     navigator.clipboard.writeText(copytext);
    //     // document.execCommand("copy");
    //     alert("Copied the text: " + copytext);
    //     console.log(copytext)
    // }


    // console.log(curdate)
    // console.log(event.date)
    // if (curdate > event.date){
    //     console.log('over')
    // }
    // else{
    //     console.log('no')
    // }

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            addComment();
        }
    };

    const sendmail = () => {
        setmedia(false)
        var msgbody1 = "K.J. somaiya Institute of Engineering and Information Technology (KJSIEIT) Sion, Mumbai %0D%0A"
        var msgbody2 = "KJSIEIT is accredited by NAAC with A grade Three programs accredited by National Board of Accreditation Best College awarded by University of Mumbai, ISTE (MH) and CSI (Mumbai) %0D%0A"
        var cname = "KJSIEIT-" + event.organizer + " is organizing a " + event.etype + ' on topic ' + event.title + ' for ' + event.target + ' %0D%0A'
        var dty = 'Date : ' + event.date + '%0D%0A Time : ' + event.tfrom + ' - ' + event.tto + '%0D%0A'
        // to = " to "
        // descc = "Description : "
        // speaker = "Speaker : "
        // msgbody4 = dte.concat(delldate, str, tme, dellfro, to, dellto, str, speaker, dellpres, sp, dellpresd, fustp)
        // msgbody5 = str.concat(str, descc, delldesc)
        // if (dellperks != undefined) {
        //     msgbodyo = msgbody5.concat(str, dellperks);
        // }
        // subj = delltitle
        // reg = "Meeting Link : "
        // msgbody5 = reg.concat(space, delllink, str, dellregfro, to, dellregto)
        // dep = "Department : "
        // faccod = "Faculty Co-ordinators : "
        // conv = "Conveners : "
        // cont = "Contact : "
        // msgbody6 = faccod.concat(dellfaccod1, sp, dellfaccod2, sp, dellfaccod3, str, conv, dellconv1, sp, dellconv2, str, cont, dellcont1, dellcont2)
        var msgbodyf = msgbody1 + msgbody2 + cname + dty
        let url = 'https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=' + event.title + '&body=' + msgbodyf + '&ui=2&tf=1&pli=1';
        window.open(url);
    }

    const CreatePdf = () => {
        // console.log('entered')
        // var fs;
        // var ts;
        // console.log('done')
        var doc = new jsPDF('l', 'in', [8, 13]);

        doc.addImage(k1, 'PNG', 0.4, 0.2, 1, 1);
        doc.addImage(k3, 'PNG', 1.4, 0.2, 5, 1);
        doc.setFontSize(17);
        // doc.addFont('arial', 'Arial', 'normal',)
        doc.addFont('Roboto-Light', 'Roboto-Light', 'normal');
        doc.addFont('Roboto-Thin', 'Roboto-Thin', 'normal');
        doc.addFont('WeezerFont', 'WeezerFont', 'normal');
        doc.addFont('Nuc', 'Nuc', 'normal');
        doc.setFont('helvetica', 'bold');
        // doc.text("Saraf Circle", 0.5, 1.3);
        doc.setFont('Roboto-Thin', 'normal');
        doc.setLineWidth(0.1);
        doc.setDrawColor(232, 232, 232);
        doc.rect(6.6, 1.3, 5.9, 0.05);//horizontal line
        doc.rect(12.6, 1.3, 0.05, 5.3);//vertical line
        doc.setFontSize(16);
        doc.text(event.title, 6.6, 1.8);
        // doc.setDrawColor(150, 150, 150);
        doc.setLineWidth(0.03);
        doc.setFontSize(13);
        doc.text('Date: ' + event.date + ', Time: ' + event.tfrom + '-' + event.tto, 6.6, 2.2);

        if (event.organizer) {
            doc.text('Organized by ' + event.organizer, 6.6, 2.5);
        }
        doc.setLineWidth(0.03);
        doc.setDrawColor(232, 232, 232);
        doc.rect(0.4, 1.6, 6, 6);
        if (event.poster) {
            doc.addImage(event.poster, 'JPG', 0.4, 1.6, 6, 6);
        }
        else {
            doc.addImage(logo1, 'JPG', 0.4, 1.6, 6, 6);
        }

        doc.save('Event.pdf');

    }
    const OpenDelete = () => {
        setdeleve(true)
    }
    const CloseDelete = () => {
        setdeleve(false)
    }
    const DeleteEvent = () => {
        axios.get(process.env.REACT_APP_DOMAIN+"/deletepreevent=" + event.id, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setdeleve(false)
                setSendingdata('Successfully deleted event')
                settt('success')
                setOpen(true)
                props.fetchData()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went Wrong')
                settt('error')
                setOpen(true)
            })
    }
    const CreateDoc = () => {
        console.log('not worked')
        const doc = new Document({
            sections: [
                {
                    properties: {},
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun("Hello World"),
                                new TextRun({
                                    text: "Foo Bar",
                                    bold: true
                                }),
                                new TextRun({
                                    text: "\tGithub is the best",
                                    bold: true
                                })
                            ]
                        })
                    ]
                }
            ]
        });

        Packer.toBlob(doc).then((blob) => {
            console.log(blob);
            saveAs(blob, 'example.docx');
            console.log("Document created successfully");
        });
        // saveDocumentToFile(
        //     doc,
        //     `user.docx`
        // );
        // var fs = require('fs');
        // const fileBuffer = HTMLtoDOCX(htmlString, null, {
        //     table: { row: { cantSplit: true } },
        //     footer: true,
        //     pageNumber: true,
        // });

        // fs.writeFile(filePath, fileBuffer, (error) => {
        //     if (error) {
        //         console.log('Docx file creation failed');
        //         return;
        //     }
        //     console.log('Docx file created successfully');
        // })
    }

    return (
        <>
            <div className="grid-h" >
                <Card square variant='outlined' className={classes2.paper + " cardbg-" + props.theme}>
                    <Grid style={{ padding: 0 }} container spacing={1}>
                        <Grid style={{ padding: 0 }} className="bg-pinkc" item xs={12} sm container>
                            <Grid className="bg-yellowc" item xs container direction="column" spacing={0}>
                                <Grid style={{ maxHeight: '80px' }} className="bg-cyanc" item >
                                    <CardHeader
                                        avatar={

                                            <Hover placement="top" delay={200} component={(
                                                <Paper className={'bg-greenc ' + classes.paper}>
                                                    <Row className="bg-orangec full-height ml-0 pt-2 pb-2" >
                                                        <Col lg="3" sm="3" xs="3" md="3" className="bg-greenc pl-0 pr-0">
                                                            <Avatar aria-label="recipe" src={proimage} className={classes.avatar2}>
                                                                {aname}
                                                            </Avatar>
                                                        </Col>
                                                        <Col lg="9" sm="9" xs="9" md="9" className="bg-yellowc pl-1">
                                                            <Link to={'profile/' + event.by.username}><h3 style={{ fontWeight: 'normal' }} className="point mb-0 bg-redc pl-0">{event.by.username}</h3></Link>
                                                            <p style={{ fontSize: '14px' }} className="mt-0 mb-0 bg-redc pl-0">{event.by.first_name} {event.by.last_name}<span className='l-wc'>{event.by.is_superuser ? ' (Super Admin)' : event.by.is_staff ? ' (Faculty)' : ' (Student)'}</span></p>
                                                            <CTooltip arrow title={emailsel} placement='top-end' aria-label="add">
                                                                <p onClick={(e) => { navigator.clipboard.writeText(event.by.email); setemailsel('Copied the Email') }} style={{ fontSize: '14px' }} className="point mt-0 mb-0">{event.by.email}</p>
                                                            </CTooltip>
                                                        </Col>
                                                    </Row></Paper>)}>
                                                <Avatar aria-label="recipe" id="AvatarView" src={proimage}
                                                    className={classes.avatar + ' point'}>
                                                    {aname}
                                                </Avatar>
                                            </Hover>
                                        }
                                        action={
                                                <UncontrolledDropdown className="bg-yellowc" nav>
                                                    <DropdownToggle nav>
                                                        <CTooltip title={'Show Menu'} placement="top">
                                                            <IconButton disableRipple className={"ml-0 point icons-" + props.theme} id="ShowMenu" aria-label="settings">
                                                                <MoreVertIcon />
                                                            </IconButton>
                                                        </CTooltip>
                                                        {/* <Tooltip placement="right" isOpen={showmenu} target="ShowMenu" toggle={toggleMenu}>
                                                        Show Menu
                                                    </Tooltip> */}
                                                    </DropdownToggle>
                                                    <DropdownMenu className={"dropdown-menu-arrow cardbg-" + props.theme} right>
                                                        <DropdownItem className="noti-title" header tag="div">
                                                            <h6 className="text-overflow m-0">Options ( {event.status} Event )</h6>
                                                        </DropdownItem>

                                                        {
                                                            (props.adminValue === true ?
                                                                    <DropdownItem className="p-0">
                                                                        <Button onClick={() => setmarkas(true)} className="text-left p-2 pl-3" style={{ width: '100%' }} color="link">
                                                                            <p className={"m-0 textsp-" + props.theme}>Mark As</p>
                                                                        </Button>
                                                                    </DropdownItem>
                                                                    :
                                                                    null
                                                                )
                                                        }
                                                        <DropdownItem className="p-0">
                                                            <Button onClick={CreatePdf} className="text-left p-2 pl-3" style={{ width: '100%' }} color="link">
                                                                <p className={"m-0 textsp-" + props.theme}>Get Data in PDF</p>
                                                            </Button>
                                                        </DropdownItem>
                                                        <DropdownItem className="p-0">
                                                            <Button className="text-left p-2 pl-3" style={{ width: '100%' }} onClick={CreateDoc} color="link">
                                                                <p className={"m-0 textsp-" + props.theme}>Get Data in DOC</p>
                                                            </Button>
                                                        </DropdownItem>
                                                        {
                                                            (props.superValue === true ?
                                                                <div>
                                                                    <DropdownItem divider className="m-0" />
                                                                    <DropdownItem className="p-0">
                                                                        <Button className="text-left p-2 pl-3" style={{ width: '100%' }} onClick={OpenDelete} color="link">
                                                                            <p className={"m-0 textsp-" + props.theme}>Delete Pre-Event</p>
                                                                        </Button>
                                                                    </DropdownItem>
                                                                </div>

                                                                :
                                                                null
                                                            )
                                                        }
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                        }
                                        title={
                                            <CTooltip title={'Pre Event'} placement="top-start">
                                                <h3 style={{ fontWeight: 'normal' }} className={"m-0 texts-" + props.theme}>{event.description}</h3>
                                            </CTooltip>}
                                        subheader={<h5 style={{ fontWeight: 'normal' }} className={"texts-" + props.theme}>{'For ' + event.target + ' • Published ' + pdate + ' • Last Edited ' + event.edate + ' ( ' + event.edate2 + ' ) '}</h5>}
                                    />
                                </Grid>
                                <Grid item xs style={{minHeight: '200px'}} >
                                    <Typography variant="body2" style={{ cursor: '' }} className={"texts-" + props.theme} >
                                        <div className="ml-3 mt-1 mb-1">Date : {event.date} Time : {event.tfrom} - {event.tto} </div>
                                        {(event.presenter ?
                                            <div className="ml-3">Presenter Details : {event.presenter}, {event.presenterd} {event.presenterc} {event.presentercon}
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {(event.description ?
                                            (event.description.length > 1 ?
                                                <div className="ml-3 mt-1 mb-1">{event.description}
                                                    <br /></div>
                                                :
                                                null
                                            )
                                            :
                                            null
                                        )}
                                        {(event.perks ?
                                            <div className="ml-3 mt-1 mb-1">Perks : {event.perks}
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {(event.regfrom ?
                                            <div className="ml-3 mt-1 mb-1"><i>Registrations from {event.regfrom} to {event.regto} </i>
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {(event.convener1 ?
                                            <div className="ml-3 mt-1 mb-1">Conveners : {event.convener1}, {event.convener2}
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {(event.teacher1 ?
                                            <div className="ml-3 mt-1 mb-1">Faculty Co-ordinators : {event.teacher1}, {event.teacher2}, {event.teacher3}
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {(event.student1 ?
                                            <div className="ml-3 mt-1 mb-1">Student Co-ordinators : {event.student1}, {event.student2}
                                                <br /></div>
                                            :
                                            null
                                        )}
                                        {/* {(event.tags.length > 0 ?
                                            <div className="ml-3 mt-1 mb-1">Tags:
                                                {event.tags.map((tag, index) => (
                                                <Chip className="ml-1 point" onClick={() => history.push({ pathname: 'view-profile', state: { "id": tag.id } })} label={tag.username} />
                                            ))}
                                            </div>
                                            :
                                            null
                                        )} */}


                                    </Typography>
                                </Grid>
                                <Grid style={{ maxHeight: '80px', backgroundColor: '' }} item>
                                    <CTooltip title={'Share'} placement="top">
                                        <IconButton disableRipple className={"ml-3 point icons-" + props.theme} id="shareIcon" onClick={openFile} aria-label="share">
                                            <ShareIcon />
                                        </IconButton>
                                    </CTooltip>
                                    <Popover
                                        id="mouse-over-popover"
                                        className={classes.popover + " "}
                                        classes={{
                                            paper: classes.paper3,
                                        }}
                                        open={file}
                                        anchorEl={anchorEl2}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        onClose={closeFile}
                                        disableRestoreFocus
                                    >
                                        <CTooltip title={'Share via Whatsapp'} placement="top">
                                            <IconButton disableRipple onClick={sendmsg} style={{ backgroundColor: '', border: '1px solid #E8E8E8' }} className={"icons-" + props.theme} aria-label="whatsapp" id="whatsappTool">
                                                <WT />
                                            </IconButton>
                                        </CTooltip>
                                        <CTooltip title={'Share via GMail'} placement="top">
                                            <IconButton disableRipple onClick={sendmail} style={{ backgroundColor: '', border: '1px solid #E8E8E8' }} className={"mt-2 point icons-" + props.theme} aria-label="gmail" id="mailTool">
                                                <ML />
                                            </IconButton>
                                        </CTooltip>
                                    </Popover>
                                    <CTooltip title={'View Comments'} placement="top">
                                        <IconButton
                                            className={clsx(classes.expand, {
                                                [classes.expandOpen]: expanded,
                                            }) + " point icons-" + props.theme}
                                            disableRipple
                                            onClick={handleExpandClick}
                                            aria-expanded={expanded}
                                        >
                                            <CommentIcon />
                                        </IconButton>
                                    </CTooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
                <Modal
                    className="modal-dialog-centered"
                    isOpen={deleve}
                    toggle={CloseDelete}>
                    <div className="modal-header">
                        <h2 className="modal-title mt-2 mb-0" id="modal-title-default">  Delete Event </h2>
                        <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={CloseDelete}> <span aria-hidden={true}>×</span> </button>

                    </div>
                    <div className="modal-header text-muted mt-0 mb-0">
                        <small>Note : If you move forward the selected event will be permanently deleted. This will be notified to the Faculty involved in this event.</small>
                    </div>
                    <Row className="modal-body bg-orangec">
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label mt-2" htmlFor="input-bags">Are you Sure ?</label>
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="modal-footer bg-tealx pt-0">
                        <Button color="inf" data-dismiss="modal" type="button" onClick={CloseDelete}> Close </Button>
                        <Button className="ml-auto" color="danger" onClick={DeleteEvent} outline> Delete </Button>
                    </div>
                </Modal>
                <Modal
                    size="lg"
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={comments}
                    toggle={CloseComments}>
                    <Card square elevation={0} >
                        <CardHeader title={ 'Pre Event Comments'} />
                        <CardContent style={{ padding: 0 }} >
                            <div style={{ minHeight: '400px', maxHeight: '400px', minWidth: '300px', backgroundColor: '', padding: '10px', overflowY: 'scroll' }}>
                                {(allcomments === undefined ?
                                    <div>Select a chat</div>
                                    :
                                    allcomments.map(function (resp, index) {
                                        if (resp.by !== undefined) {
                                            if (resp.by.id === props.username) {
                                                return (
                                                    // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                    <div className={classes.fulldiv}>
                                                        <div className={classes.offerSelf}>
                                                            <div style={{ display: 'inline-block' }} className="point">
                                                                <Avatar className={classes.small} style={{ float: 'left' }} src={process.env.REACT_APP_DOMAIN+'' + resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                <p style={{ float: 'left' }} className="m-0 ml-2 point">You</p>
                                                            </div>
                                                            <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                return (
                                                    // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                    <div className={classes.fulldiv}>
                                                        <div className={classes.offerOther}>
                                                            <div style={{ display: 'inline-block' }} className="point">
                                                                <Avatar className={classes.small} style={{ float: 'left' }} src={process.env.REACT_APP_DOMAIN+'' + resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                <Link to={'profile/'+resp.by.username}><p style={{ float: 'left' }} className="m-0 ml-2 point">{resp.by.username}</p></Link>
                                                            </div>
                                                            <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        }
                                        return(null)
                                    })
                                )}
                            </div>
                        </CardContent>
                        <CardActions>
                            <Input placeholder="Add a Comment" value={incomment} onChange={(e) => setincomment(e.target.value)} ref={commentinput} onKeyDown={handleKeypress} /><Button outline onClick={addComment} >Go</Button>
                        </CardActions>
                    </Card>
                </Modal>
                <Modal
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={markas}
                    toggle={CloseMarkas}>
                    <div style={{ backgroundColor: '', width: '100%', padding: '10px', overflowY: '' }}>
                        {(event.status === 'Pending' ?
                            <div>
                                <Button onClick={() => markEventAs('Ongoing')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Ongoing</p>
                                </Button>
                                <Button onClick={() => markEventAs('Confirmed')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Confirmed</p>
                                </Button>
                                <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Cancelled</p>
                                </Button>
                            </div>
                            :
                            (event.status === 'Ongoing' ?
                                <div>
                                    <Button onClick={() => markEventAs('Pending')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Pending</p>
                                    </Button>
                                    <Button onClick={() => markEventAs('Confirmed')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Confirmed</p>
                                    </Button>
                                    <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Cancelled</p>
                                    </Button>
                                </div>
                                :
                                (event.status === 'Confirmed' ?
                                    <div>
                                        <Button onClick={() => markEventAs('Ongoing')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Ongoing</p>
                                        </Button>
                                        <Button onClick={() => markEventAs('Pending')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Pending</p>
                                        </Button>
                                        <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Cancelled</p>
                                        </Button>
                                    </div>
                                    :
                                    null
                                )
                            )
                        )}
                    </div>
                </Modal>
            </div>
            <div className="grid-v" >
                <Card className={"full-width mb-4 cardbg-" + props.theme} square variant="outlined" style={{ backgroundColor: 'pink' }} >
                    <CardHeader
                        avatar={
                            <Link to={'profile/' + event.by.username}><Avatar aria-label="recipe" src={proimage}
                                className={classes.avatar}>
                                {aname}
                            </Avatar></Link>
                        }
                    action={
                        <div>
                            {(event.by.id === props.username || props.superValue ?
                                <IconButton disableRipple className="mr-0">
                                    <Edit />
                                </IconButton>
                                :
                                <div></div>
                            )}

                            <UncontrolledDropdown nav>
                                <DropdownToggle nav>
                                    <IconButton disableRipple className="ml-0" aria-label="settings">
                                        <MoreVertIcon />
                                    </IconButton>
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                    <DropdownItem className="noti-title" header tag="div">
                                        <h6 className="text-overflow m-0">Options ( {event.status} Event )</h6>
                                    </DropdownItem>
                                    {(event.status === 'Finished' ?
                                        null
                                        :
                                        <DropdownItem className="p-0">
                                            <Button onClick={() => setmarkas(true)} className="text-left" style={{ width: '100%' }} color="link">
                                                <p className="text-dark m-0">Mark As</p>
                                            </Button>
                                        </DropdownItem>
                                    )}
                                    <DropdownItem className="p-0">
                                        <Button onClick={CreatePdf} className="text-left" style={{ width: '100%' }} color="link">
                                            <p className="text-dark m-0">Get Data in PDF</p>
                                        </Button>
                                    </DropdownItem>
                                    <DropdownItem className="p-0">
                                        <Button className="text-left" style={{ width: '100%' }} onClick={CreateDoc} color="link">
                                            <p className="text-dark m-0">Get Data in DOC</p>
                                        </Button>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>

                    }
                    title={
                        <CTooltip title={'Pre Event'} placement="top-start">
                            <h3 style={{ fontWeight: 'normal' }} className={"m-0 texts-" + props.theme}>{event.description}</h3>
                        </CTooltip>}
                    subheader={<h5 style={{ fontWeight: 'normal' }} className={"texts-" + props.theme}>{'For ' + event.target + ' • Published ' + pdate + ' • Last Edited ' + event.edate + ' ( ' + event.edate2 + ' ) '}</h5>}
                />

                <CardMedia
                    className={classes.media + ' ' + classes.cover + " point"}
                    image={(event.poster === null ? logo1 : event.poster)}
                    title={(event.poster === null ? "No Poster" : "Poster of " + event.title)}
                    onClick={(event.poster === null ? (event) => console.log('yes') : (event) => handleMedia(event, event.poster))}
                />
                <CardContent style={{ backgroundColor: '' }}>
                    <Typography variant="body2" color="textSecondary" component="p">
                        {/* {(event.tags.length > 0 ?
                            <div className="ml- mt-1 mb-1">Tags:
                                                {event.tags.map((tag, index) => (
                                <Chip className="ml-1 point" onClick={() => history.push({ pathname: 'view-profile', state: { "id": tag.id } })} label={tag.username} />
                            ))}
                            </div>
                            :
                            null
                        )} */}
                    </Typography>
                </CardContent>
                <CardActions disableSpacing>
                    <IconButton onClick={openFile} aria-label="share">
                        <ShareIcon />
                    </IconButton>
                    <Popover
                        id="mouse-over-popover"
                        className={classes.popover + "popp"}
                        classes={{
                            paper: classes.paper3,
                        }}
                        open={file}
                        anchorEl={anchorEl2}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        onClose={closeFile}
                        disableRestoreFocus
                    >
                        <IconButton onClick={sendmsg} style={{ backgroundColor: 'white', border: '1px solid #E8E8E8' }} aria-label="whatsapp">
                            <WT />
                        </IconButton>
                        <IconButton onClick={sendmail} style={{ backgroundColor: 'white', border: '1px solid #E8E8E8' }} className="mt-2" aria-label="gmail">
                            <ML />
                        </IconButton>
                    </Popover>
                    <IconButton
                        className={clsx(classes.expand, {
                            [classes.expandOpen]: expanded,
                        })}
                        onClick={handleExpandClick2}
                        aria-expanded={expanded}
                        aria-label="show more"
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <CardContent style={{ padding: '10px' }}>
                        <Card square style={{ padding: 0 }} elevation={0} >
                            <CardHeader style={{ padding: 0 }} title={'Comments'} />
                            <CardContent style={{ padding: 0 }} >
                                <div style={{ minHeight: '400px', maxHeight: '400px', minWidth: '300px', backgroundColor: '', padding: '10px', overflowY: 'scroll' }}>
                                    {(allcomments === undefined ?
                                        <div>Select a chat</div>
                                        :
                                        allcomments.map(function (resp, index) {
                                            if (resp.by !== undefined) {
                                                if (resp.by.id === props.username) {
                                                    return (
                                                        // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                        <div className={classes.fulldiv}>
                                                            <div className={classes.offerSelf}>
                                                                <div style={{ display: 'inline-block' }}>
                                                                    <Avatar className={classes.small} style={{ float: 'left' }} src={resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                    <p style={{ float: 'left' }} className="m-0 ml-2 point">You</p>
                                                                </div>
                                                                <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                else {
                                                    return (
                                                        // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                        <div className={classes.fulldiv}>
                                                            <div className={classes.offerOther}>
                                                                <div style={{ display: 'inline-block' }}>
                                                                    <Avatar className={classes.small} style={{ float: 'left' }} src={resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                    <Link to={'profile/'+resp.by.username}><p style={{ float: 'left' }} className="m-0 ml-2 point">{resp.by.username}</p></Link>
                                                                </div>
                                                                <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            }
                                            return(null)
                                        })
                                    )}
                                </div>
                            </CardContent>
                            <CardActions style={{ padding: 0, paddingTop: '10px' }}>
                                <Input placeholder="Add a Comment" value={incomment} onChange={(e) => setincomment(e.target.value)} ref={commentinput} onKeyDown={handleKeypress} /><Button outline onClick={addComment} >Go</Button>
                            </CardActions>
                        </Card>
                    </CardContent>
                </Collapse>
            </Card>
            </div>
            {media &&
                <div className="text-center" onClick={CloseMedia} style={{ height: '100vh', width: '100vw', backgroundColor: 'black', position: 'fixed', top: 0, left: 0, zIndex: 10, opacity: '100%' }}>
                    <img alt="Event Poster" style={{ height: '100%', width: 'auto', opacity: '100%', zIndex: 11 }} src={event.poster} />
                </div>}
            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
            </Snackbar>
            {/* <div className="menuItem backbut" onClick={handlePClose}>...</div> */}
        </>
    );
};

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        superValue: state.switchRoutes.superadmin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Header);
